import {Injectable} from '@angular/core';
import {CrudRepository, toMultipleSelectItem} from '@abydos-angular/store';
import {coalesce, LabelValueVO, RestResponse} from '@abydos-angular/core';
import {map, share, tap} from 'rxjs/operators';
import {forkJoin, Observable} from 'rxjs';
import {ActivityListVO, ActivityVO} from './activity.interfaces';
import {ActivityRestService} from '../api/activity-rest.service';
import {CategoryRestService} from '@abydos-angular/rest-api';

@Injectable()
export class ActivityRepository extends CrudRepository<ActivityVO, ActivityListVO> {

    constructor(private activityRestService: ActivityRestService, private categoryRestService: CategoryRestService) {
        super(activityRestService);
    }

    getPartnerDocument(id: number): Observable<RestResponse> {
        return this.activityRestService.getPartnerDocument(id)
    }

    override initSelectItems(): Observable<Map<string, LabelValueVO[]>> {
        return coalesce(this.getCachedSelectItem('initSelectItems'),
            forkJoin([
                this.categoryRestService.listWithParents(['activity_label'])
            ])
        .pipe(
            map(([categoryResponse]) => {
                return {
                    activityLabel: RestResponse.create({
                        status: 'OK',
                        data: categoryResponse.getData()!
                            .filter(value => value.parentCategoryCode === 'activity_label')
                    })
                };
          })
          , toMultipleSelectItem(['activityLabel'])
          , share()
          , tap((itemMap) => {
            this.selectItemCache.set('initSelectItems', itemMap);
          }))
      )!;
    }
}
